/* eslint-disable */


/**
 * Create styles for `<ReportPage />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<ReportPage />` styles
 */
const reportPageStyles = ({ theme }) => ({
  container: {
    height: `100%`,
  },
  label: {
    color: theme.palette.grey[500],
    fontSize: theme.spacing(1) * 1.6,
  },
});

export default reportPageStyles;
